<template>
  <div class="container-fluid">
    <!-- Title -->
    <div class="row flex-row justify-content-between">
      <div class="mb-4">
        <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
          Outflow or Expense Report
        </div>
        <div class="s-14 py-0 text-dak">
          {{ branchItem ? branchItem.parentNames : "" }}
        </div>
      </div>
      <div class="c-pointer">
        <el-dropdown trigger="click" class="w-100">
          <div class="d-flex default-btn text-dark w-100" size="large">
            <span class="mt-1 s-14 text-head" style="color: #0040ff"
              >Export</span
            >
            <div class="mt-0 ml-1">
              <el-icon :size="10" class="el-icon--right primary--text"
                ><ArrowDownBold
              /></el-icon>
            </div>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(bookType, index) in bookTypeList"
                :key="index"
              >
                <a
                  v-if="selectedTab === 'summary'"
                  class="no-decoration text-dark"
                  @click="downloadFile1(bookType)"
                >
                  {{ bookType.name }}
                </a>
                <a
                  v-if="selectedTab === 'details'"
                  class="no-decoration text-dark"
                  @click="downloadFile2(bookType)"
                >
                  {{ bookType.name }}
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <div class="row bg-gray-300 justify-content-center py-3 border-radius-8">
      <div class="col-md-12 pl-4">
        <div class="row align-items-center">
          <div class="col-md-8 col-12">
            <div class="row align-items-center">
              <div class="col-md-3 col-12">
                <div class="text-md-right text-left s-14 fw-400 text-dak">
                  Date Range
                </div>
              </div>
              <div class="col-md-3 col-12 px-0 mb-3 mb-md-0">
                <div class="col-12 px-md-1">
                  <el-date-picker
                    v-model="startDate"
                    type="date"
                    format="DD/MM/YYYY"
                    class="w-100 calendar"
                  />
                </div>
              </div>
              <div class="col-md-3 col-12 px-0 mb-3 mb-md-0">
                <div class="col-12 px-md-1">
                  <el-date-picker
                    v-model="endDate"
                    type="date"
                    format="DD/MM/YYYY"
                    class="w-100 calendar"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div
              class="col-md-12 mt-3 d-flex justify-content-center justify-content-md-end px-0"
            >
              <el-button
                class="c-pointer w-100"
                :color="primarycolor"
                :loading="loading"
                round
                @click="generateReport"
              >
                Generate Report
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="d-flex justify-content-center mt-5 cursor-pointer">
          <div
            style="background: #e0f2ff"
            class="p-1 d-flex align-items-center border-radius-8"
          >
            <div
              v-for="tab in tabs"
              :key="tab.id"
              style="color: #08162e"
              class="s-12 px-3"
              :class="{ active: selectedTab === tab.id }"
              @click="handleTabClick(tab.id)"
            >
              {{ tab.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="selectedTab === 'summary'">
      <div class="col-md-12 px-0 d-flex flex-wrap">
        <div class="col-md-6">
          <IncomeStatmentColumnChart
            domId="chart1"
            title=""
            distance="5"
            subtitle=""
            :titleMargin="10"
            :data="columnChartData.series"
            :series="columnChartData.categories"
            yAxisText="Amount"
          />
        </div>
        <div class="col-md-6 mt-3 mt-md-0">
          <IncomeStatementPieChart
            v-if="selectedTab === 'summary'"
            domId="chart"
            title=""
            :summary="pieChartData"
          />
        </div>
      </div>
      <div class="col-md-12 px-0">
        <ExpenseSummary
          :endDate="endDate"
          :startDate="startDate"
          :bookType="bookTypeItem1"
          :fileHeaderToExport="fileHeaderToExport"
          :fileToExport="fileToExport"
          :fileName="fileName"
          :incomeStatementSummaryData="incomeStatementData"
          @download-complete="handleDownloadComplete"
        />
      </div>
    </div>
    <!-- Accounts Table -->
    <div
      class="mt-3 row"
      id="element-to-print"
      v-if="selectedTab === 'details'"
    >
      <div
        class="container-fluild table-main remove-styles2 remove-border responsiveness"
      >
        <div class="row" v-if="bookTypeItem2 == 'pdf'">
          <div
            class="col-md-12 px-0 d-none"
            :class="{ 'd-none': bookTypeItem2 == 'pdf' }"
          >
            <table
              id="table"
              class="table remove-styles mt-0 col-md-12 table-hover table-header-area"
            >
              <thead>
                <tr>
                  <th>
                    <div class="row">
                      <div class="col-md-12 d-flex justify-content-between">
                        <div>
                          <div class="s-20 fw-500">Outflow Report</div>
                          <div class="s-18 font-weight-600">
                            {{ tenantDisplayName }}
                          </div>
                          <div class="s-18 fw-500">
                            <span class="mr-1"> Date Range: </span>
                            <span>
                              {{ formatDate(startDate) }}
                              to {{ formatDate(endDate) }}
                            </span>
                          </div>
                        </div>
                        <div>
                          <img
                            :src="churchLogo"
                            v-if="churchLogo"
                            class="link-image mr-2"
                            alt=""
                          />
                          <img
                            src="../../../assets/dashboardlinks/churchcloud.png"
                            v-else
                            class="link-image mr-2"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
        <table
          id="table"
          class="table remove-styles mt-0 table-hover table-header-area"
        >
          <thead class="table-header-ar">
            <tr class="font-weight-bold">
              <th>ACCOUNTS</th>
              <th class="text-right"></th>
              <th class="text-right">
                <div class="text-dak s-14">{{ formatDate(startDate) }}</div>
                <div class="text-dak s-14">to {{ formatDate(endDate) }}</div>
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(transactions, accountName, index) in groupedTransactions"
            :key="accountName"
          >
            <!-- Only show if there are expenses -->
            <tr class="category-header" v-if="index === 0">
              <td colspan="3" class="table-header-area-main fw-400 s-14">
                <div>Expense</div>
              </td>
            </tr>

            <!-- Loop through expense accounts -->

            <!-- For each transaction in this account -->
            <tr
              v-for="(item, index) in transactions"
              :key="`${accountName}-${index}`"
            >
              <td>
                <div class="font-weight-medium">{{ item.accountName }}</div>
                <div class="text-muted small">{{ item.description }}</div>
              </td>
              <td class="text-left d-flex justify-content-end">
                {{ formatDate(item.date) }}
              </td>
              <td class="text-right">
                {{ item.currency?.symbol || currentUser.currencySymbol }}
                {{ formatAmount(Math.abs(item.amount)) }}
              </td>
            </tr>

            <!-- Total row for Expenses -->
          </tbody>
          <tbody>
            <tr class="table-header-area-main">
              <td class="font-weight-bold">Total Expense</td>
              <td></td>
              <td class="text-right font-weight-bold">
                {{ currentUser.currencySymbol }}
                {{ formatAmount(totalExpense) }}
              </td>
            </tr>
          </tbody>
          <div class="mt-4"></div>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, nextTick, watchEffect, inject } from "vue";
// import exportService from "../../../services/exportFile/exportservice";
import exportService from "../../../services/exportFile/exportserjs";
import IncomeStatementPieChart from "@/components/charts/ReportPieChart.vue";
import IncomeStatmentColumnChart from "../../../components/charts/ReportColumnChart.vue";
import { useStore } from "vuex";
import axios from "@/gateway/backendapi";
import { ElNotification } from "element-plus";
import ExpenseSummary from "./ExpenseSummary.vue";
import incomeExpenseHelper from "./Helper/Incomeexpenses-helper.js";
import dateFormatter from "../../../services/dates/dateformatter";
// Date & Filters
// const selectedDate = ref(new Date(Date.now()));
const startDate = ref(new Date().setFullYear(new Date().getFullYear() - 1));
const endDate = ref(new Date(Date.now()));
const loading = ref(false);
const primarycolor = inject("primarycolor");
const incomeStatementData = ref({});
const incomeStatement = ref([]);
const showReport = ref(false);
const tableData = ref({});
const transactions = ref([]);
const displayTitle = ref(false);
const chartForIcomeAndExpense = ref([]);
const fileName = ref("Expnse Report");
const bookTypeList = ref([
  { name: "xlsx" },
  { name: "csv" },
  { name: "txt" },
  { name: "pdf" },
]);
// const selectedFileType = ref({});
const fileHeaderToExport = ref([]);
const fileToExport = ref([]);
const bookTypeItem = ref("");
const bookTypeItem1 = ref("");
const bookTypeItem2 = ref("");
const tenantData = ref({});
const churchLogo = ref("");
const store = useStore();
const selectedTab = ref("summary");
const branchItem = ref({});
branchItem.value = JSON.parse(localStorage.getItem("branchItem"));

const tabs = [
  { id: "summary", label: "Summary" },
  { id: "details", label: "Details" },
];

const formatDate = (date) => {
  return dateFormatter.monthDayYear(date);
};
const handleDownloadComplete = (success) => {
  if (success) {
    console.log("Export completed successfully");
    ElNotification.success({ message: "Export completed!" });
  } else {
    console.error("Export failed");
    ElNotification.error({ message: "Export failed!" });
  }
};

const handleTabClick = async (tabId) => {
  selectedTab.value = tabId;

  // Only refresh data when switching to summary tab
  if (tabId === "summary" || tabId === "details") {
    await getReport();
  }
};
const downloadFile1 = async (item) => {
  if (selectedTab.value === "summary") bookTypeItem1.value = null;
  await nextTick();
  bookTypeItem1.value = item.name;
};
const downloadFile2 = async (item) => {
  bookTypeItem2.value = item.name;
  await nextTick();
  exportService.downLoadExcel(
    item.name,
    document.getElementById("element-to-print"),
    fileName.value,
    fileHeaderToExport.value,
    fileToExport.value
  );
  ElNotification.success({ message: "Export completed!" });
};
const tenantDisplayName = computed(() => {
  if (!tenantData.value.churchName) return "";
  const name =
    tenantData.value.churchName.length < 20
      ? tenantData.value.churchName
      : `${tenantData.value.churchName.slice(0, 20)}...`;
  return name;
});
const getChurchProfile = async () => {
  if (branchItem.value && branchItem.value.id) {
    try {
      let { data } = await axios.get(
        `/GetChurchProfileById?tenantId=${branchItem.value.id}`
      );
      churchLogo.value = data.returnObject.logo;
    } catch (err) {
      console.error(err);
    }
  } else {
    try {
      let { data } = await axios.get(
        `/GetChurchProfileById?tenantId=${getUser.value.tenantId}`
      );
      churchLogo.value = data.returnObject.logo;
    } catch (err) {
      console.error(err);
    }
  }
};
const getUser = computed(() => {
  if (
    !store.getters.currentUser ||
    (store.getters.currentUser &&
      Object.keys(store.getters.currentUser).length == 0)
  )
    return "";
  return store.getters.currentUser;
});
watchEffect(() => {
  if (getUser.value) {
    tenantData.value = getUser.value;
    getChurchProfile();
  }
});

// Sample Data

const currentUser = computed(() => {
  if (store && Object.keys(store.getters.currentUser).length > 0)
    return store.getters.currentUser;
  return "";
});
const generateReport = async () => {
  loading.value = true;
  try {
    await getReport();
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const getReport = async () => {
  loading.value = true;
  if (branchItem.value && branchItem.value.id) {
    try {
      const { data } = await axios.get(
        `/api/BranchReports/financials/getIncomeStatementReport?startDate=${new Date(
          startDate.value
        ).toLocaleDateString("en-US")}&endDate=${new Date(
          endDate.value
        ).toLocaleDateString("en-US")}&branchId=${branchItem.value.id}`
      );
      incomeStatementData.value = data;
      transactions.value = data.transactions.filter((t) => t !== null);
      tableData.value = incomeExpenseHelper.formatAccounts(data.transactions);
      incomeStatement.value = data.transactions.filter((i) => i !== null);

      if (incomeStatement.value.length > 0) {
        showReport.value = true;
      } else {
        showReport.value = false;
      }

      chartForIcomeAndExpense.value = data;
      // churchIncomes(incomeStatement.value, "accountCategory");
      // churchExpense(incomeStatement.value, "accountCategory");
      pieChart(incomeStatement.value, "accountCategory");
      groupedFundType();
      groupAccountCategoery();
      loading.value = false;

      /* function to call service and populate table */
      setTimeout(() => {
        fileHeaderToExport.value = exportService.tableHeaderToJson(
          document.getElementsByTagName("th")
        );
        fileToExport.value = exportService.tableToJson(
          document.getElementById("table")
        );
      }, 1000);
      /* End function to call service and populate table */
      loading.value = false;
    } catch (error) {
      console.log(error);
      loading.value = false;
    }
  } else {
    try {
      const { data } = await axios.get(
        `/api/Reports/financials/getIncomeStatementReport?startDate=${new Date(
          startDate.value
        ).toLocaleDateString("en-US")}&endDate=${new Date(
          endDate.value
        ).toLocaleDateString("en-US")}`
      );
      incomeStatementData.value = data;
      transactions.value = data.transactions.filter((t) => t !== null);
      tableData.value = incomeExpenseHelper.formatAccounts(data.transactions);
      incomeStatement.value = data.transactions.filter((i) => i !== null);

      if (incomeStatement.value.length > 0) {
        showReport.value = true;
      } else {
        showReport.value = false;
      }

      chartForIcomeAndExpense.value = data;
      // churchIncomes(incomeStatement.value, "accountCategory");
      // churchExpense(incomeStatement.value, "accountCategory");
      pieChart(incomeStatement.value, "accountCategory");
      groupedFundType();
      groupAccountCategoery();
      loading.value = false;

      /* function to call service and populate table */
      setTimeout(() => {
        fileHeaderToExport.value = exportService.tableHeaderToJson(
          document.getElementsByTagName("th")
        );
        fileToExport.value = exportService.tableToJson(
          document.getElementById("table")
        );
      }, 1000);
      /* End function to call service and populate table */
      loading.value = false;
    } catch (error) {
      console.log(error);
      loading.value = false;
    }
  }
};
getReport();

// Calculate totals by account
const expenseTotalsByAccount = computed(() => {
  const totals = {};

  for (const [accountName, transactions] of Object.entries(
    groupedTransactions.value
  )) {
    totals[accountName] = transactions.reduce(
      (sum, t) => sum + Math.abs(t.amount),
      0
    );
  }

  return totals;
});

// Calculate the grand total for all expenses
const totalExpense = computed(() => {
  return Object.values(expenseTotalsByAccount.value).reduce(
    (sum, total) => sum + total,
    0
  );
});

const pieChartData = computed(() => {
  if (!incomeStatementData.value?.transactionsByAccountCategory) return [];

  // Find the Income category
  const incomeCategory =
    incomeStatementData.value.transactionsByAccountCategory.find(
      (cat) => cat.categoryName === "Expense"
    );

  if (!incomeCategory) return [];

  return incomeCategory.accounts.map((account) => ({
    name: account.accountName,
    value: Math.abs(account.totalAmount),
    fund: account.fund,
  }));
});

const columnChartData = computed(() => {
  if (!incomeStatementData.value?.transactionsByAccountCategory)
    return { categories: [], series: [] };

  const incomeCategory =
    incomeStatementData.value.transactionsByAccountCategory.find(
      (cat) => cat.categoryName === "Expense"
    );

  if (!incomeCategory) return { categories: [], series: [] };

  // Group by fund
  const funds = {};
  incomeCategory.accounts.forEach((account) => {
    if (!funds[account.accountName]) {
      funds[account.accountName] = [];
    }
    funds[account.accountName].push({
      name: account.accountName,
      value: Math.abs(account.totalAmount),
    });
  });

  // Prepare data for Highcharts
  const series = [];
  const categories = [];

  Object.entries(funds).forEach(([fundName, accounts]) => {
    accounts.forEach((account) => {
      categories.push(account.name);
      series.push({
        name: fundName,
        data: [account.value],
      });
    });
  });

  return {
    categories,
    series,
  };
});

const groupedTransactions = computed(() => {
  const expenseGroups = {};

  transactions.value.forEach((transaction) => {
    // Only process expense transactions
    if (transaction.accountCategory === "Expense") {
      if (!expenseGroups[transaction.accountName]) {
        expenseGroups[transaction.accountName] = [];
      }
      expenseGroups[transaction.accountName].push(transaction);
    }
  });

  return expenseGroups;
});
// Format Amount
const formatAmount = (amount) =>
  amount.toLocaleString("en-NG", { minimumFractionDigits: 2 });
</script>

<style scoped>
.table th,
.table td {
  border-top: none;
}
.active {
  background: #ffffff;
  color: #08162e;
  font-weight: 700;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  /* padding: 15px 0; */
}
.bg-secondary {
  background-color: #f8f9fa !important;
}
button.el-button {
  height: 36px !important;
  width: 139px !important;
  padding: 13px 24px !important;
  font-size: 13px !important;
}
.table-main {
  width: 100% !important;
  box-shadow: 0 0.063rem 0.25rem #02172e45 !important;
  /* border: 0.063rem solid #dde2e6 !important; */
  /* border-radius: 30px !important; */
  text-align: left !important;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem !important;
}

.remove-styles {
  border: none !important;
  box-shadow: none !important;
  border-bottom: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.remove-styles2 {
  padding-right: 0;
  padding-left: 0;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
table tbody tr,
table thead tr {
  border-bottom: 1px solid rgba(0, 0, 1, 0.2);
}
table tbody tr:first-child {
  border-bottom: none !important;
}
table tbody tr:last-child {
  border-bottom: none !important;
}

.remove-border {
  box-shadow: none !important;
}
.table {
  width: 100% !important;
  box-shadow: none !important;
  border: none !important;
  text-align: left;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem;
}

.table thead th {
  font-weight: 700 !important;
  color: #000000 !important;
  font-size: 14px !important;
}
.table tbody tr {
  font-weight: 400 !important;
  color: #000000 !important;
  font-size: 14px !important;
}

.table-header-area-main {
  background-color: #d4dde4 !important;
  /* background-color: #f4f4f4; */
}

.table-header-area {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
